import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LandingPage } from './features/landing/LandingPage';
import { SearchPage } from './features/search/SearchPage';
import { LookupPage } from './features/lookup/LookupPage';
import { PublicCompanyPage } from './features/public/PublicCompanyPage';
import { PricingPage } from './features/pricing/PricingPage';
import { DocsPage } from './features/docs/DocsPage';
import { SignInPage, SignUpPage } from './features/auth/AuthPages';
import { VerifyEmailPage, ResetPasswordPage } from './features/auth/AccountLinkPages';
import { LegalPage } from './features/legal/LegalPage';
import { StatusPage } from './features/status/StatusPage';
import { OptOutPage } from './features/public/OptOutPage';
import { NotFoundPage } from './features/NotFoundPage';

/**
 * Routes.
 *
 * Order matters in one place: `/:country/:identifier` is the public company page
 * and would otherwise swallow `/pricing`, `/signin` and every other single-segment
 * route. React Router v7 ranks static segments above dynamic ones, so the declared
 * order below is documentation rather than behaviour — but the country segment is
 * additionally validated inside the component.
 */
export function App(): React.ReactNode {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<LandingPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="lookup/:lookupId" element={<LookupPage />} />
        <Route path="pricing" element={<PricingPage />} />
        <Route path="docs/api" element={<DocsPage />} />
        <Route path="signin" element={<SignInPage />} />
        {/* The landing pages for the links in confirmation and reset e-mails.
            They are not decoration: without them those links hit the 404 page and
            the user cannot tell whether their account was confirmed. */}
        <Route path="verify-email" element={<VerifyEmailPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route path="signup" element={<SignUpPage />} />
        <Route path="signup/:plan" element={<SignUpPage />} />
        <Route path="legal/:document" element={<LegalPage />} />
        <Route path="status" element={<StatusPage />} />
        <Route path="opt-out" element={<OptOutPage />} />
        {/* Public company page: /br/19131243000197 */}
        <Route path=":country/:identifier" element={<PublicCompanyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
